.section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
